import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaginaDesconhecidaComponent } from './modules/pagina-desconhecida/pagina-desconhecida.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'alterar-senha',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'nova-senha',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'mensagem-em-duas-etapas',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'senha-expirada',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },

  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
    data: {
      headerPage: {
        titlePage: '',
        sidac: false,
      },
    },
  },

  {
    path: 'usuario',
    loadChildren: () =>
      import('./modules/usuario/usuario.module').then(
        (mod) => mod.UsuarioModule
      ),
    data: {
      breadcrumb: 'Usuários',
    },
  },
  {
    path: 'perfil',
    loadChildren: () =>
      import('./modules/perfil/perfil.module').then((m) => m.PerfilModule),
  },
  {
    path: 'dominios',
    loadChildren: () =>
      import('./modules/dominios/dominios.module').then(
        (m) => m.DominiosModule
      ),
  },
  {
    path: 'pessoa',
    loadChildren: () =>
      import('./modules/pessoa/pessoa.module').then((m) => m.PessoaModule),
  },
  {
    path: 'entidade',
    loadChildren: () =>
      import('./modules/entidade/entidade.module').then(
        (m) => m.EntidadeModule
      ),
  },
  {
    path: 'movimentacao-societaria',
    loadChildren: () =>
      import(
        './modules/movimentacao-societaria/movimentacao-societaria.module'
      ).then((m) => m.MovimentacaoSocietariaModule),
  },
  {
    path: 'vinculo',
    loadChildren: () =>
      import('./modules/vinculo/vinculo.module').then((m) => m.VinculoModule),
  },
  {
    path: 'consulta',
    loadChildren: () =>
      import('./modules/consulta/consulta.module').then(
        (m) => m.ConsultaModule
      ),
  },
  {
    path: 'lista-mailling',
    loadChildren: () =>
      import('./modules/mailling/mailling.module').then(
        (m) => m.MaillingModule
      ),
  },
  {
    path: 'pendencia',
    loadChildren: () => import('./modules/pendencia/pendencia.module').then(m => m.PendenciaModule)
  },
  {
    path: 'auditoria',
    loadChildren: () => import('./modules/auditoria/auditoria.module').then(m => m.AuditoriaModule)
  },
  {
    path: 'parametrizacao',
    loadChildren: () => import('./modules/parametrizacao/parametrizacao.module').then(m => m.ParametrizacaoModule)
  },

  {
    path: 'relatorio',
    loadChildren: () => import('./modules/relatorios/relatorios.module').then(m => m.RelatoriosModule)
  },

  {
    path: '**',
    component: PaginaDesconhecidaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
